import { safeStorage } from './safeStorage';

const AUTH_OTP_ATTRIBUTION_KEY = 'gweffit_auth_otp_attribution_log';
const MAX_ENTRIES = 25;

function readEntries() {
  try {
    const raw = safeStorage.get(AUTH_OTP_ATTRIBUTION_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeEntries(entries) {
  try {
    safeStorage.set(AUTH_OTP_ATTRIBUTION_KEY, JSON.stringify(entries.slice(0, MAX_ENTRIES)));
  } catch {}
}

export function recordAuthOtpAttribution(entry) {
  const nextEntry = {
    timestamp: new Date().toISOString(),
    ...entry,
  };
  const entries = [nextEntry, ...readEntries()];
  writeEntries(entries);
  try {
    if (typeof window !== 'undefined') {
      window.__gweffitAuthOtpAttributionLog = entries;
    }
  } catch {}
  console.log('[auth_otp_attribution]', nextEntry);
  return nextEntry;
}

export function getAuthOtpAttributionLog() {
  return readEntries();
}
